import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setJwt } from '../features/workstationSlice';

const useStartSession = () => {
  const dispatch = useDispatch();

  const onStartSession = useCallback(
    (event: WindowEventMap['message']) => {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (
        event.origin.includes('https://manual-sales-registration-ui.retailsvc.com') ||
        event.origin.includes('https://manual-sales-registration-ui.retailsvc.dev') ||
        event.origin.includes('localhost')
      ) {
        if (event.data && event.data.type && event.data.type === 'TOKEN') {
          dispatch(setJwt(event.data?.payload));
        }
      }
    },
    [dispatch],
  );

  useEffect(() => {
    window.addEventListener('message', onStartSession);

    return () => {
      window.removeEventListener('message', onStartSession);
    };
  }, [dispatch, onStartSession]);
};

export default useStartSession;
